import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuWorkspaceMembershipTypeAppResource from './LuWorkspaceMembershipTypeAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

export const NOTIFICATION_TYPE = {
    EMAIL: 'email',
    TEXT: 'text',
};

class ActivityHistorySavedViewAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'activity-history-saved-view';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'activity/history/saved/views';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'userUuid',
            'projectUuid',
            'projectMembershipTypeUuid',
            'actions',
            'notificationFrequencyInMins',
            'notificationType',
            'isDefault',
            'project',
            'projectMembershipType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            project: WorkspaceAppResource,
            projectMembershipType: LuWorkspaceMembershipTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            project: 'project_uuid',
            projectMembershipType: 'project_membership_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            projectUuid: {
                type: 'string',
            },
            projectMembershipTypeUuid: {
                type: 'string',
            },
            notificationFrequencyInMins: {
                type: 'integer',
            },
            notificationType: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            isDefault: {
                type: 'boolean',
            },
            actions: {
                type: 'array',
            },
        };
    }

    get status() {
        return this.notificationFrequencyInMins ? true : false;
    }

    set status(value) {
        if (value) {
            this.setAttribute('notificationFrequencyInMins', 7 * 24 * 60);
            return;
        }
        this.setAttribute('notificationFrequencyInMins', null);
    }
}

export default ActivityHistorySavedViewAppResource;
